import { VITTA_SUBSCRIPTION_PERMISSION } from '@/modules/leadIndication/entities/leadIndication.enum';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import { useMemo } from 'react';

/**
 * Centraliza as verificações de permissão do fluxo de Indicações
 * (Vitta por Assinatura).
 */
const useLeadIndicationPermissions = () => {
  const { checkUserHasPermission } = useCurrentUser();

  const canRead = useMemo(
    () => checkUserHasPermission(VITTA_SUBSCRIPTION_PERMISSION.READ),
    [checkUserHasPermission],
  );

  const canWrite = useMemo(
    () => checkUserHasPermission(VITTA_SUBSCRIPTION_PERMISSION.WRITE),
    [checkUserHasPermission],
  );

  return {
    canRead,
    canWrite,
  };
};

export default useLeadIndicationPermissions;
